module.exports = "<div class=\"container\">\r\n    <div class=\"row\">\r\n        <div class=\"col-xs-12\">\r\n            <h1>Lorem Ipsum</h1>\r\n            <p>Lorem ipsum dolor sit amet ...</p>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/html-page-snippets/page.basic.html
// module id = 626
// module chunks = 0